// extracted by mini-css-extract-plugin
export default {"root":"AXBDJ","check":"_9RbFa","description":"bTXR2","bold":"JC0wl"};